// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2 2V12C2 13.1 2.9 14 4 14H14',
  'M5.25 11V9.3M9.1 11V3.1M12.95 11V5.8',
];
